import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { makeStyles } from '@mui/styles';
import classnames from 'classnames';
import React from 'react';
const useStyles = makeStyles({
    rotated: {
        transform: 'rotate(180deg)',
    },
});
const ArrowRightIcon = ({ className, rotated }) => {
    const classes = useStyles();
    return React.createElement(KeyboardArrowRightIcon, { className: classnames(className, { [classes.rotated]: rotated }) });
};
export default ArrowRightIcon;
